import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, defer, from } from 'rxjs';
import { ConfirmBoxComponent } from './confirm-box/confirm-box.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmBox {
  constructor(private modalService: NgbModal) { }

  public confirm(message: string, options?: { title?: string }): Observable<boolean> {
    const modal = this.modalService.open(ConfirmBoxComponent, { beforeDismiss: () => false });
    modal.componentInstance.message = message;
    modal.componentInstance.title = options?.title;
    return defer(() => from(modal.result));
  }
}